import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import { LANG_TEXT } from '../../../../constants/language';
import { IOrders } from '../../order.types';
import { useStyles } from '../../styles';
import Card from '../Card/Card';
import Loader from '../Loader/Loader';

const PreOrdersList = ({
  orders,
  loading,
  toggleDrawer,
  openDrawer,
  setSelectedOrder,
}: {
  orders: IOrders[];
  loading: boolean;
  toggleDrawer: (open: boolean) => void;
  openDrawer: boolean;
  setSelectedOrder: React.Dispatch<React.SetStateAction<IOrders | undefined>>;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box className={classes.PreOrderList}>
        <Loader />
      </Box>
    );
  }

  if (!orders.length) {
    return (
      <Box className={classes.PreOrderList}>
        <EmptyState title={t(LANG_TEXT.EMPTY_PRE_ORDER)} />;
      </Box>
    );
  }

  return (
    <Box className={classes.PreOrderList}>
      {orders.map((item) => (
        <Card key={item.id} order={item} isPreOrder toggleDrawer={toggleDrawer} openDrawer={openDrawer} setSelectedOrder={setSelectedOrder} />
      ))}
    </Box>
  );
};

export default PreOrdersList;
